import { Injectable } from '@angular/core';

import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarHorizontalPosition,
  MatSnackBarRef,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

import { SedsSnackbarComponent } from '../seds-snackbar.component';
import { SedsSnackbarConfig } from '../models/seds-snackbar-config.model';
import { SedsSnackbarButtonAction } from '../enum/seds-snackbar-button-action';

@Injectable({
  providedIn: 'root',
})
export class SedsSnackbarService {
  constructor(private readonly snackBar: MatSnackBar) {}

  open(message: string, config?: SedsSnackbarConfig): MatSnackBarRef<any> {
    const configuration = new MatSnackBarConfig();
    config = config || {};
    configuration.duration = config.duration;
    configuration.panelClass = 'dark-seds-snackbar';
    configuration.horizontalPosition = config.horizontalPosition as MatSnackBarHorizontalPosition;
    configuration.verticalPosition = config.verticalPosition as MatSnackBarVerticalPosition;
    configuration.data = message;
    const configToOpen = {
      ...configuration,
      data: {
        message,
        buttonText: config.typeButton || undefined,
        iconLeft: config.iconLeft || undefined,
        closeIcon: config.typeButton === SedsSnackbarButtonAction.CLOSE,
      },
    };
    return this.snackBar.openFromComponent(SedsSnackbarComponent, configToOpen);
  }
}
